// SixDetailService.ts
import type { ParticipantsResponseDTO, SixActivityDTO, SixFileDTO, SixFolderDTO, SixDetailDTO, DeleteFileResponse, SixFilesApiResponse } from "@/types/six/SixDTOs";

export abstract class SixDetailService {
  /* meta */
  abstract getMeta(id: string): Promise<SixDetailDTO>;

  /* files */
  abstract fetchFiles(id: string): Promise<SixFilesApiResponse>;
  abstract uploadFile(id: string, file: File, path?: string): Promise<SixFileDTO>;
  abstract markFileDownloaded(sixId: string, fileId: string): Promise<void>;
  abstract deleteFile(sixId: string, fileId: string): Promise<DeleteFileResponse>;

  /* folders */
  abstract createFolder(id: string, folderName: string, folderPath: string): Promise<SixFolderDTO>;
  abstract deleteFolder(sixId: string, folderPath: string): Promise<DeleteFileResponse>;

  /* activity */
  abstract fetchActivity(id: string): Promise<SixActivityDTO[]>;
  abstract exportActivityCsv(id: string): Promise<Blob>;

  /* participant */
  abstract fetchParticipants(id: string): Promise<ParticipantsResponseDTO>;
}
